import { useState } from "react";
import { Button, Input, Label, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';

function DeleteBody(props: any) {
    const [canDelete, setCanDelete] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)

    const handleChange = (e: any) => {
        e.preventDefault();
    };

    const handleDeleteField = (e: any) => {
        setCanDelete(!canDelete)
    }

    const deleteRequest = async (id: number) => {
        setIsDeleting(true)
		try {
			await props.delete(id)
		} catch (error: any) {
			console.error("err",error);
			props.avisoAlert({
				show: true,
				message: `Error:`,
				extraMessage: error.message,
				status: "danger",
			},5000);
		}
        props.toggle()
        setIsDeleting(false)
        props.refresh()
    }

    return (
        <>
            <ModalHeader toggle={props.toggle} charcode="close">
                {props.title}
            </ModalHeader>
            <ModalBody>
                <p>¿Estás seguro que deseas eliminar a "<b>{props.item.name}</b>"?</p>
                <p><span className="text-danger">Esta acción no se puede deshacer.</span></p>
                <Input
                    id="check"
                    name="check"
                    type="checkbox"
                    onChange={handleDeleteField}
                    autoComplete="off"
                    className="me-2"
                />
                <Label htmlFor="check"> Confirmar</Label>
            </ModalBody>
            <ModalFooter>
                <div className="row col-12">
                    <div className="col-6">
                        <div className="d-flex justify-content-end">
                            <Button
                                onClick={props.toggle}
                                disabled={isDeleting}
                                className="mx-2"
                            >
                                Cancelar
                            </Button>
                        </div>
                    </div>
                    <div className="col-6">
                        <Button
                            color="danger"
                            onClick={() => deleteRequest(props.item.id)}
                            disabled={isDeleting || !canDelete}
                        >
                            {isDeleting ? <div>Eliminando... <Spinner animation="border" variant="light" size="sm" /></div> : props.title.split(' ')[0]}
                        </Button>
                    </div>
                </div>

            </ModalFooter>
        </>
    );
}

export default DeleteBody